import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setFormValue as _setFormValue } from 'redux/modules/newClient';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Tooltip } from 'components';
import * as styles from './NewClient.scss';
var NewClientFormStep1 = (_dec = connect(function (state, props) {
  return {
    savedBillingConfig: state.organization.orgBillingConfig,
    formValues: props.formValues ? props.formValues : state.newClient,
    organization: state.organization.current,
    theme: state.theme
  };
}, function (d, props) {
  return {
    setFormValue: function setFormValue() {
      return props.setFormValue ? props.setFormValue.apply(props, arguments) : d(_setFormValue.apply(void 0, arguments));
    }
  };
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClientFormStep1, _Component);

  var _super = _createSuper(NewClientFormStep1);

  function NewClientFormStep1(props) {
    var _this;

    _classCallCheck(this, NewClientFormStep1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBillingChange", function (e, val) {
      _this.props.setFormValue('billingMethod', 'orgConfig', val);

      if (val === 'ads_only') {
        _this.props.setFormValue('step1Valid', 'validation', true);
      } else if (val === 'end_to_end') {
        _this.validateManagementFee(_this.props.formValues.orgConfig.managementFee);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleManagementChange", function (e, val) {
      _this.props.setFormValue('managementMethod', 'orgConfig', val);

      setTimeout(function () {
        _this.validateManagementFee(_this.props.formValues.orgConfig.managementFee);

        _this.validateAdsBudget(_this.props.formValues.orgConfig.adsBudget);
      }, 500);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e, val) {
      _this.props.setFormValue(e.target.id, 'orgConfig', val);

      if (e.target.id === 'managementFee') {
        _this.validateManagementFee(val);
      }

      if (e.target.id === 'adsBudget') {
        _this.validateAdsBudget(val);
      }

      if (e.target.id === 'adsCommissionPercent') {
        _this.validateAdsCommission(val);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateAdsCommission", function (val) {
      if (parseFloat(val) < 0 || parseFloat(val) > 25 || isNaN(parseFloat(val)) || !"".concat(val).match(/^[-+]?[0-9]*\.?[0-9]+$/)) {
        _this.setState({
          adsCommissionErrorText: 'Must be at least 0% and no greater than 25%.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else {
        _this.setState({
          adsCommissionErrorText: ''
        });

        _this.props.setFormValue('step1Valid', 'validation', true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateAdsBudget", function (val) {
      if (parseInt(val, 10) < 0 || isNaN(parseInt(val, 10))) {
        _this.setState({
          adsBudgetErrorText: 'Must be a 0 or more.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (val === '') {
        _this.setState({
          adsBudgetErrorText: 'Must be 0 or more.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else {
        _this.setState({
          adsBudgetErrorText: ''
        });

        if (_this.props.formValues.orgConfig.billingMethod === 'likeable_smb' || _this.props.formValues.orgConfig.billingMethod === 'license') {
          _this.props.setFormValue('step1Valid', 'validation', true);
        }

        _this.validateManagementFee(_this.props.formValues.orgConfig.managementFee);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateManagementFee", function (val) {
      if (_this.props.formValues.orgConfig.billingMethod === 'license' || _this.props.formValues.orgConfig.billingMethod === 'likeable_smb') {
        return true;
      }

      if (_this.props.formValues.orgConfig.managementMethod === 'likeableManaged' && _this.props.formValues.orgConfig.billingMethod === 'end_to_end' && (parseInt(val) < parseInt(_this.props.contractInfo.terms.llManagedMonthlyFee) || val === '')) {
        _this.setState({
          managementFeeErrorText: "Must be equal to or greater than $".concat(_this.props.contractInfo.terms.llManagedMonthlyFee, ".")
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (_this.props.formValues.orgConfig.managementMethod === 'partnerManaged' && parseInt(val) < parseInt(_this.props.contractInfo.terms.partnerManagedMonthlyFee)) {
        _this.setState({
          managementFeeErrorText: "Must be equal to or greater than $".concat(_this.props.contractInfo.terms.partnerManagedMonthlyFee, ".")
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (parseInt(val) > 9999) {
        _this.setState({
          managementFeeErrorText: 'Must be less than $10,000.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (isNaN(parseInt(val))) {
        _this.setState({
          managementFeeErrorText: 'Must be a positive integer.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else {
        console.log('no trouble');

        _this.setState({
          managementFeeErrorText: ''
        });

        _this.props.setFormValue('step1Valid', 'validation', true);
      }
    });

    _this.state = {
      adsCommissionErrorText: '',
      adsBudgetErrorText: '',
      managementFeeErrorText: '',
      currentAdsBudget: props.savedBillingConfig && props.savedBillingConfig.adsBudget ? parseInt(props.savedBillingConfig.adsBudget) : 0
    };
    return _this;
  }

  _createClass(NewClientFormStep1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateManagementFee(this.props.formValues.orgConfig.managementFee);
      this.validateAdsBudget(this.props.formValues.orgConfig.adsBudget);
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          edit = _this$props.edit;
      var hasExistingLicenses = contractInfo && contractInfo.totals && contractInfo.totals.clientsUsed < contractInfo.totals.clientsPermitted;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var existingClientLabel = contractInfo ? /*#__PURE__*/React.createElement("span", null, "Use Existing License", ' ', /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12
        }
      }, "(Using ", contractInfo.totals.clientsUsed, " of ", contractInfo.totals.clientsPermitted, ")")) : null;
      return /*#__PURE__*/React.createElement("div", null, !this.props.edit && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Billing Method", /*#__PURE__*/React.createElement(Tooltip, {
        name: "billing",
        message: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Bill Full Amount:"), " Likeable Local will handle all client billing."), /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Bill Ads Only:"), " Partner will be billed a license fee. Ads Budget will be billed separately."), hasExistingLicenses && /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Use Existing License:"), " Use a license included with your agreement."))
      })), hasExistingLicenses ? /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "billingMethod",
        defaultSelected: this.props.formValues.orgConfig.billingMethod,
        onChange: this.handleBillingChange
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "end_to_end",
        label: "Bill Full Amount",
        style: {
          marginBottom: 4
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "ads_only",
        label: "Bill Ads Only",
        style: {
          marginBottom: 4
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "existing_license",
        label: existingClientLabel
      })) : /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "billingMethod",
        defaultSelected: this.props.formValues.orgConfig.billingMethod,
        onChange: this.handleBillingChange
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "end_to_end",
        label: "Bill Full Amount",
        style: {
          marginBottom: 4
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "ads_only",
        label: "Bill Ads Only",
        style: {
          marginBottom: 4
        }
      }))), !['existing_license', 'license'].includes(this.props.formValues.orgConfig.billingMethod) && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          marginTop: 32
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Management Method", /*#__PURE__*/React.createElement(Tooltip, {
        name: "management",
        message: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, partnerName, " Managed:"), " ", partnerName, " responsible for client management."), /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Likeable Local Managed:"), " Likeable Local will handle client management."))
      })), /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "managementMethod",
        defaultSelected: this.props.formValues.orgConfig.managementMethod,
        onChange: this.handleManagementChange
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "partnerManaged",
        label: "".concat(partnerName, " Managed ($").concat(contractInfo.terms.partnerManagedMonthlyFee, ")"),
        style: {
          marginBottom: 4
        },
        disabled: this.props.formValues.orgConfig.billingMethod === 'existing_license'
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "likeableManaged",
        label: "Likeable Local Managed ($".concat(contractInfo.terms.llManagedMonthlyFee, ")"),
        disabled: this.props.formValues.orgConfig.billingMethod === 'existing_license'
      }))), this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          marginTop: 32
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle,
        style: {
          marginBottom: 0,
          marginTop: 24
        }
      }, "Client Charges", /*#__PURE__*/React.createElement(Tooltip, {
        name: "options",
        message: /*#__PURE__*/React.createElement("div", null, this.props.formValues.orgConfig.billingMethod === 'end_to_end' && /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Monthly Management Fee:"), " Includes both the ", partnerName, " monthly fee and the Likeable Local license fee."), /*#__PURE__*/React.createElement("div", {
          className: styles.tooltipItem
        }, /*#__PURE__*/React.createElement("strong", null, "Monthly Ads Budget:"), " How much money this client can spend each month on Facebook ads."))
      })), this.props.formValues.orgConfig.billingMethod === 'end_to_end' && /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          left: -10
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        className: styles.dollarInput,
        floatingLabelText: "Client Fee (includes license fee)",
        errorText: this.state.managementFeeErrorText,
        hintText: "Monthly Management Fee",
        id: "managementFee",
        value: this.props.formValues.orgConfig.managementFee,
        onChange: this.handleTextFieldChange
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          left: -10
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        errorText: this.state.adsBudgetErrorText,
        floatingLabelText: "Monthly Ads Budget",
        hintText: "Monthly Ads Budget",
        id: "adsBudget",
        value: this.props.formValues.orgConfig.adsBudget,
        onChange: this.handleTextFieldChange
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement(TextField, {
        errorText: this.state.adsCommissionErrorText,
        floatingLabelText: "Ads Commission Percent",
        hintText: "Ads Commission Percent",
        id: "adsCommissionPercent",
        value: this.props.formValues.orgConfig.adsCommissionPercent,
        onChange: this.handleTextFieldChange
      }), /*#__PURE__*/React.createElement("span", null, "%"), /*#__PURE__*/React.createElement(Tooltip, {
        style: {
          zIndex: 999,
          paddingTop: 5,
          marginLeft: 15
        },
        name: "adscommissions",
        message: /*#__PURE__*/React.createElement("div", null, "This is the percent of the Monthly Ads Budget that ", contractInfo.contract.businessName, " will receive as commission.")
      }))));
    }
  }]);

  return NewClientFormStep1;
}(Component)) || _class);
export { NewClientFormStep1 as default };